/* ============================================================
   LEOSPORTZ — theme.js
   Orchestrator: loads all modules and initializes on DOM ready.
   Modules: theme-utils, theme-cart, theme-product, theme-nav, theme-search
   ============================================================ */

'use strict';

document.addEventListener('DOMContentLoaded', () => {
  // Core utilities (loaded first by theme.liquid)
  // Leosportz.utils is already available

  // Navigation
  Leosportz.AnnouncementBar.init();
  Leosportz.MobileNav.init();
  Leosportz.StickyHeader.init();
  Leosportz.SkipLink.init();
  Leosportz.FilterDrawer.init();
  Leosportz.PriceRange.init();
  Leosportz.FilterAccordion.init();

  // Cart
  Leosportz.CartDrawer.init();

  // Product page
  Leosportz.ProductVariants.init();
  Leosportz.Gallery.init();
  Leosportz.ProductTabs.init();
  Leosportz.QtySelectors.init();
  Leosportz.QuickAdd.init();
  Leosportz.Wishlist.init();
  Leosportz.DeliveryChecker.init();

  // Search
  Leosportz.Search.init();

  // Sliders
  Leosportz.FeaturedSlider.init();

  console.log('🦁 Leosportz theme initialized');
});
